module.exports = __webpack_public_path__ + "img/v3.18f2bc54.png";